<template>
  <div>
    <el-dialog
      :close-on-click-modal="true"
      class="my_dialog"
      :title="title"
      :visible.sync="dialogVisible"
      :before-close="closeDialog"
      :width="width"
      :show-close="false"
      append-to-body

      center
    >
      <div>
        <!-- 试题 -->
        <add-question
          ref="addQuestion"
          :isField="isField"
          :isShowOtherTypes="isShowOtherTypes"
          v-if="dialogType == 'addQuestion'"
          :courseId="courseId"
          :subjectId="subjectId"
          :dialogVisible="dialogVisible"
        ></add-question>
        <question-preview
          v-if="dialogType == 'questionPreview'"
          :subjectId="subjectId"
          :questionId="questionId"
          :dialogVisible="dialogVisible"
        ></question-preview>
        <div v-if="dialogType == 'deleteQuestion'" class="deletePrompt">
          <p v-show="deleteNum == 1">您确定删除试题<span class="name" v-html="deleteName">"{{ deleteName }}"</span>吗？</p>
          <p v-show="deleteNum > 1">您确定删除选中的<span class="name">"{{ deleteNum }}道"</span>试题吗？</p>
        </div>

        <!-- 试卷 -->
        <add-test-paper
          ref="addTestPaper"
          :isField="isField"
          :showUpload="showUpload"
          :courseId="courseId"
          v-if="dialogType == 'addTestPaper'"
          :subjectId="subjectId"
          :dialogVisible="dialogVisible"
        ></add-test-paper>
        <div v-if="dialogType == 'deleteTestPaper'" class="deletePrompt">
          <p v-show="deleteNum == 1">您确定删除试卷<span class="name">"{{ deleteName }}"</span>吗？</p>
          <p v-show="deleteNum > 1">您确定删除选中的<span class="name">"{{ deleteNum }}套"</span>试卷吗？</p>
        </div>

        <!-- 共享资源 -->
        <add-link
          ref="addLink"
          v-if=" dialogType == 'addLink' || dialogType == 'editLink' "
          :courseId="courseId"
          :tableRowData=" dialogType == 'editLink' ? tableData : {}"
        ></add-link>
        <div v-if="dialogType == 'deleteResource'" class="deletePrompt">
          <p v-show="deleteNum == 1">您确定删除资源<span class="name">"{{ deleteName }}"</span>吗？</p>
          <p v-show="deleteNum > 1">您确定删除选中的<span class="name">"{{ deleteNum }}个"</span>资源吗？</p>
        </div>

      </div>
      <div
        slot="footer"
        class="dialog-footer"
        v-if="dialogType == 'questionPreview'"
      >
        <span class="btns cancel_btn" @click="closeDialog">关 闭</span>
      </div>
      <div slot="footer" class="dialog-footer" v-else>
        <span class="btns cancel_btn" @click="closeDialog">取 消</span>
        <span v-if="isDedicated" class="btns confirm_btn" @click="conformBtn_dedicated">确 定</span>
        <span v-else class="btns confirm_btn" @click="conformBtn" :disabled="isDisabled">确 定</span>
      </div>
    </el-dialog>

    <!-- 输入密码 -->
    <el-dialog
      title="输入密码"
      :visible.sync="dialogVisible_password"
      width="30%"
      :before-close="handleClose"
      class="dialog_encrypt"
    >
      <div>
        <el-form
          :model="ruleForm_password"
          status-icon
          ref="ruleForm_password"
          label-width="80px"
          class="demo-ruleForm"
          size="small"
        >
          <el-form-item label="密码:">
            <el-input
              type="password"
              v-model="ruleForm_password.passwordEditor"
              autocomplete="off"
              show-password
            ></el-input>
          </el-form-item>
        </el-form>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="handleClose" size="small">取 消</el-button>
        <el-button type="primary" @click="confirmPassword()" size="small"
        >确 定</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
import addQuestion from "../new_course_module/editCourse/question/addQuestion.vue";
import questionPreview from "../new_course_module/editCourse/question/questionPreview";
import addTestPaper from "../new_course_module/editCourse/testPaper/addTestPaper";
import addLink from './addLink.vue'
import * as api from "@/api/newCourseApi.js";
import * as testPaperApi from "@/api/testPaperApi";
export default {
  name: "n_dialog",
  components: {
    addQuestion,
    questionPreview,
    addTestPaper,
    addLink
  },
  props: {
    dialogVisible: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: "",
    },
    dialogType: {
      type: String,
      default: "",
    },
    width: {
      type: [String, Number],
      default: "",
    },
    courseId: {
      type: [Number, String],
      default: "",
    },
    subjectId: {
      type: [Number, String],
      default: "",
    },
    questionId: {
      type: [Number, String],
      default: "",
    },
    deleteNum: {
      type: [Number, String],
      default: "",
    },
    deleteName: {
      type: String,
      default: "",
    },
    tableRowData: {
      type: Object,
      default: ()=>{}
    },
    isField: {
      type: Boolean,
      default: false,
    },
    showUpload: {
      type: Boolean,
      default: false,
    },
    isDedicated: {
      type: Boolean,
      default: false,
    },
    isShowOtherTypes: { //除单，多，判，实操
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      tableData: {},
      isDisabled: false,
      dialogVisible_password: false, // 输入密码
      ruleForm_password: {
        paperId: "",
        passwordEditor: "",
        ids: [],
      },
    };
  },
  watch: {
    tableRowData: {
      handler: function(val) {
        if (val == undefined) return;
        if ( Object.keys(val).length != 0 ) {
          this.tableData = val;
        } else {
          this.tableData = {};
        }
      },
      immediate: true,
      deep: true,
    }
  },
  created() {},
  mounted() {},
  methods: {
    closeDialog() {
      if ( this.dialogType == "addLink" || this.dialogType == "editLink" ) {
        this.$refs.addLink.$refs.ruleForm.resetFields();
      }
      this.$emit("closeDialog");
    },
    handleSave(ids) {
      let params = {
        categoryId: this.$refs[this.dialogType].searchParams.categoryId,
        resourceIds: ids,
        resourceType:
          this.dialogType == "addQuestion"
            ? 3
            : this.dialogType == "addTestPaper"
            ? 5
            : "",
      };
      this.isDisabled = true
      api
        .AddResource(params)
        .then((res) => {
          if (res.code == "0") {
            if(this.isField){
              this.$parent.initList()
            }
            this.$parent.initList ?  this.$parent.findPageResource('treeGet') : false
            this.$message.success(res.msg);
          } else {
            this.$message.error(res.msg);
          }
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          this.closeDialog();
          this.isDisabled = false
        });
    },
    conformBtn() {

      // 试题 & 试卷
      if (
        this.dialogType == "addQuestion" ||
        this.dialogType == "addTestPaper"
      ) {
        /**
         * 确定判断必填
         * 1、资源分类
         * 2、试题选择
         * */
        if (this.$refs[this.dialogType].searchParams.categoryId == "") {
          this.$message.warning("请选择资源分类");
          return;
        }
        if (this.$refs[this.dialogType].chooseNum == 0) {
          this.$message.warning(
            this.dialogType == "addQuestion" ? "请选择试题" : "请选择试卷"
          );
          return;
        }
        let data = this.$refs[this.dialogType].multipleSelection;
        let ids = data.map((item) => {
          return item.id;
        });
        if (this.dialogType === 'addTestPaper' && data.filter(item => item.encryption).length >= 2) {
          this.$message.warning("添加加密试卷单次最多一条哦~");
          return;
        }
        if (this.dialogType === 'addTestPaper' && data.filter(item => item.encryption).length === 1) {
          this.dialogVisible_password = true;
          this.ruleForm_password.paperId = data.filter(item => item.encryption)[0]['id'];
          this.ruleForm_password.ids = ids;
          return;
        }
        this.handleSave(ids)

      } else if (
        this.dialogType == "deleteQuestion" ||
        this.dialogType == "deleteResource"
      ) {
        let ids = this.$parent.multipleSelection.map(
          (item) => item.categoryResourceId
        );
        api
          .DeleteResource(ids)
          .then((res) => {
            if (res.code == "0") {
              this.$message.success(res.msg);
            } else {
              this.$message.error(res.msg);
            }
          })
          .catch((err) => {
            console.log(err);
          })
          .finally(() => {
            this.closeDialog();
          });
      } else if (
        this.dialogType == "deleteTestPaper"
      ) {
        let ids = this.$parent.multipleSelection.map(
          (item) => item.categoryResourceId
        );
        api.DeleteResourceByCourse({
          courseId: this.courseId,
          ids: ids
        })
          .then((res) => {
            if (res.code == "0") {
              this.$message.success(res.msg);
            } else {
              this.$message.error(res.msg);
            }
          })
          .catch((err) => {
            console.log(err);
          })
          .finally(() => {
            this.closeDialog();
          });
      }
      // 添加链接
      if ( this.dialogType == "addLink" || this.dialogType == "editLink" ) {
        this.$refs.addLink.$refs.ruleForm.validate((valid) => {
          if (valid) {
            this.dialogType == "addLink" ? this.addLink() : this.editLink();
          } else {
            return false;
          }
        });
      }
    },
    conformBtn_dedicated() {
      this.$emit("conformFunc");
    },

    addLink() {
      api.categoryResourceAddLink({
        ...this.$refs.addLink.ruleForm
      }).then(res => {
        if (res.code == "0") {
          this.$message.success(res.msg);
        } else {
          this.$message.error(res.msg)
        }
      }).catch(err => {
        console.log(err);
      }).finally(()=>{
        this.closeDialog();
      })
    },
    editLink() {
      api.categoryResourceUpdateLink({
        ...this.$refs.addLink.ruleForm
      }).then(res => {
        if (res.code == "0") {
          this.$message.success(res.msg);
        } else {
          this.$message.error(res.msg)
        }
      }).catch(err => {
        console.log(err);
      }).finally(()=>{
        this.closeDialog();
      })
    },
    // 关闭密码弹窗
    handleClose() {
      this.dialogVisible_password = false;
    },
    // 验证密码 - 输入密码   确认
    confirmPassword() {
      testPaperApi
        .EditPaperDecryption({
          paperId: this.ruleForm_password.paperId,
          passwordEditor: this.ruleForm_password.passwordEditor,
        })
        .then((res) => {
          if (res.code == "0") {
            if (res.data) {
              this.ruleForm_password.passwordEditor = "";
              this.dialogVisible_password = false;
              // tod
              this.handleSave(this.ruleForm_password.ids)
            } else {
              this.$message.error("密码错误。");
            }
          } else {
            this.$message.error(res.msg);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    }
  },
};
</script>

<style scoped lang="scss">
.my_dialog {
  /deep/ .el-dialog {
    border-radius: 24px !important;
  }
  /deep/ .el-dialog__header {
    height: 48px;
    line-height: 48px;
    background: #f5f5f7;
    border-radius: 24px 24px 0px 0px;
    padding: 0px;
    .el-dialog__title {
      font-size: 16px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #0f0d11;
    }
  }
  /deep/ .el-dialog__body {
    padding: 10px 24px 0px;
  }
  /deep/ .el-dialog__footer {
    height: 48px;
    padding: 0px;
    border-top: 1px solid #d2d2d7;
  }

  .dialog-footer {
    margin-top: 5px;
    /*height: 48px;*/
    /*display: flex;*/
    /*justify-content: center;*/
    /*align-items: center;*/
  }
  .btns {
    display: inline-block;
    width: 80px;
    height: 32px;
    line-height: 32px;
    font-size: 12px;
    /*display: flex;*/
    /*justify-content: center;*/
    /*align-items: center;*/
    border-radius: 6px;
    cursor: pointer;
    box-sizing: border-box;
  }
  .confirm_btn {
    background: linear-gradient(135deg, #1890ff 0%, #00b3f7 100%, #00b3f7 100%);
    /*margin-right: 24px;*/
    color: #ffffff;
    &:hover {
      opacity: 0.8;
    }
  }
  .cancel_btn {
    border-radius: 6px;
    border: 1px solid #1890ff;
    color: #1890ff;
  }

  .deletePrompt {
    height: 114px;
    font-size: 14px;
    color: #42414D;
    font-weight: 400;
    padding: 20px 6px 0px 6px;
    letter-spacing: 2px;
    line-height: 24px;
    text-align: justify;
    .name {
      color: #1890FF;
    }
  }
  /deep/ .question_title{
    line-height: 40px;
    height: 40px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    img{
      display: none;
    }
  }
  /deep/ .question_title *{
    font-size: 12px !important;
    color: #262628 !important;
    font-weight: 400 !important;
    font-style: inherit !important;
    text-decoration: inherit !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/szrt_revision/components/n_dialog.vue